module.exports = __webpack_public_path__ + "img/Flag_of_Nigeria.85b4736e.svg";